var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotsHorizontalBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 10C1.66699 9.55801 1.84259 9.13409 2.15515 8.82153C2.46771 8.50897 2.89163 8.33337 3.33366 8.33337C3.77569 8.33337 4.19961 8.50897 4.51217 8.82153C4.82473 9.13409 5.00033 9.55801 5.00033 10C5.00033 10.4421 4.82473 10.866 4.51217 11.1786C4.19961 11.4911 3.77569 11.6667 3.33366 11.6667C2.89163 11.6667 2.46771 11.4911 2.15515 11.1786C1.84259 10.866 1.66699 10.4421 1.66699 10Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33301 10C8.33301 9.55801 8.5086 9.13409 8.82116 8.82153C9.13372 8.50897 9.55765 8.33337 9.99967 8.33337C10.4417 8.33337 10.8656 8.50897 11.1782 8.82153C11.4907 9.13409 11.6663 9.55801 11.6663 10C11.6663 10.4421 11.4907 10.866 11.1782 11.1786C10.8656 11.4911 10.4417 11.6667 9.99967 11.6667C9.55765 11.6667 9.13372 11.4911 8.82116 11.1786C8.5086 10.866 8.33301 10.4421 8.33301 10Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C15 9.55801 15.1756 9.13409 15.4882 8.82153C15.8007 8.50897 16.2246 8.33337 16.6667 8.33337C17.1087 8.33337 17.5326 8.50897 17.8452 8.82153C18.1577 9.13409 18.3333 9.55801 18.3333 10C18.3333 10.4421 18.1577 10.866 17.8452 11.1786C17.5326 11.4911 17.1087 11.6667 16.6667 11.6667C16.2246 11.6667 15.8007 11.4911 15.4882 11.1786C15.1756 10.866 15 10.4421 15 10Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsHorizontalBlack);
export default __webpack_public_path__ + "static/media/threeDotsHorizontal-black.1fd1419ceecb962543d07b2f388a7977.svg";
export { ForwardRef as ReactComponent };